import React, { createContext, useContext, useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { sendGlobalErrorProps } from 'cu-master-layout-prop-manager';
import { getEnrichStatus } from '../api';
import { isDefined, processEnrichments } from '../utils';

type EnrichmentContextType = {
  enrichedStatus: boolean;
  enrichmentProcessing: boolean;
};

const EnrichmentContext = createContext<EnrichmentContextType | undefined>(
  undefined
);

export const EnrichmentProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [enrichmentStates, setEnrichmentStates] = useState({
    MelissaApi: false,
    ClearinghouseApi_20_24: false,
    ClearinghouseApi_25_34: false,
    ClearinghouseApi_35_40: false,
    processingEnrichments: false,
  });

  const { data: enrichResult } = useQuery(
    getEnrichStatus({
      useErrorBoundary: false,
      onError: (error) => {
        if (
          (error as AxiosError).response?.status === 500 ||
          (error as AxiosResponse).status === 500
        ) {
          sendGlobalErrorProps({
            errorType: 'generalError',
          });
        }
      },
    })
  );

  const enrichData =
    isDefined(enrichResult) && typeof enrichResult !== 'string'
      ? enrichResult
      : null;

  useEffect(() => {
    if (enrichData) {
      setEnrichmentStates(processEnrichments(enrichData));
    }
  }, [enrichData]);

  const enrichedStatus =
    enrichmentStates.MelissaApi ||
    enrichmentStates.ClearinghouseApi_20_24 ||
    enrichmentStates.ClearinghouseApi_25_34 ||
    enrichmentStates.ClearinghouseApi_35_40;

  const enrichmentProcessing = enrichmentStates.processingEnrichments;

  return (
    <EnrichmentContext.Provider
      value={{ enrichedStatus, enrichmentProcessing }}
    >
      {children}
    </EnrichmentContext.Provider>
  );
};

export const useEnrichment = () => {
  const context = useContext(EnrichmentContext);
  if (context === undefined) {
    throw new Error('useEnrichment must be used within an EnrichmentProvider');
  }
  return context;
};
